// TODO: get rid of and use window.structuredClone instead??
export const deepClone = (obj: any) => {
    if (obj === null || typeof obj !== 'object') {
        return obj; // Primitive values are returned as-is
    }

    if (typeof obj === 'function') {
        return obj.bind({}); // Clone functions, preserving their scope
    }

    const clone: any = Array.isArray(obj) ? [] : {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            clone[key] = deepClone(obj[key]);
        }
    }

    return clone;
};
